/** EST3 revision materiality classification — mirrors Wave 7 governance compare. */
export const EST3_MATERIALITY_CLASSIFICATIONS = [
  'ADMINISTRATIVE',
  'OPERATIONAL',
  'COST_ONLY',
  'COMMERCIAL_PRICING',
  'MIXED_MATERIAL',
] as const;

export function est3MaterialityColor(classification: string): string {
  switch (classification) {
    case 'MIXED_MATERIAL':
      return 'red';
    case 'COST_ONLY':
      return 'orange';
    case 'COMMERCIAL_PRICING':
      return 'blue';
    case 'OPERATIONAL':
      return 'purple';
    default:
      return 'default';
  }
}

export const EST3_REVISION_DELTA_FIELDS: Array<{ key: string; label: string; money?: boolean }> = [
  { key: 'total_estimated_cost', label: 'Total Estimated Cost', money: true },
  { key: 'direct_cost', label: 'Direct cost', money: true },
  { key: 'indirect_cost', label: 'Indirect', money: true },
  { key: 'risk_allowance', label: 'Risk allowance', money: true },
  { key: 'contingency', label: 'Contingency', money: true },
  { key: 'escalation', label: 'Escalation', money: true },
  { key: 'fx_allowance', label: 'FX allowance', money: true },
  { key: 'final_bid_price', label: 'Final bid price', money: true },
  { key: 'profit_amount', label: 'Profit', money: true },
  { key: 'margin_actual', label: 'Margin %' },
  { key: 'duration_months', label: 'Duration (mo)' },
  { key: 'discount', label: 'Discount', money: true },
  { key: 'negotiation_reserve', label: 'Negotiation reserve', money: true },
];
